/**
 * Type safe version of Object.keys
 * Can probably remove this whenever typescript adds it
 */
export const objectKeys = (obj) => Object.keys(obj);
